import React, { Suspense, lazy } from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import CpsLoader from '../../common/CpsLoader';

const FormRichTextEditor = lazy(() => import('./FormRichTextEditor'));

interface FormRichTextEditorLazyProps extends FieldRenderProps {
  isLoading?: boolean;
}

export const FormRichTextEditorLazy: React.FC<FormRichTextEditorLazyProps> = props => {
  return (
    <Suspense fallback={<CpsLoader />}>
      <FormRichTextEditor
        value={props.value}
        validationMessage={props.validationMessage}
        touched={props.touched}
        id={props.id}
        valid={props.valid}
        disabled={props.disabled}
        hint={props.hint}
        label={props.label}
        wrapperStyle={props.wrapperStyle}
        optional={props.optional}
        modified={props.modified}
        visited={props.visited}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        name={props.name}
        isLoading={props.isLoading}
        children={props.children}
      />
    </Suspense>
  );
};
